import React from "react";

export default function SelectInput({
    label,
    value,
    onChange,
    options = [],
    error = "",
    required = false,
}) {

    return (

        <div className="mb-5">

            {label && (
                <label className="block mb-2 text-sm font-medium text-gray-700">
                    {label}
                    {required && (
                        <span className="text-red-500 mr-1">*</span>
                    )}
                </label>
            )}

            <select
                value={value}
                onChange={onChange}
                className={`
                    w-full
                    rounded-xl
                    border
                    px-4
                    py-3
                    outline-none

                    ${error
                        ? "border-red-500"
                        : "border-gray-300 focus:border-primary"}
                `}
            >

                <option value="">
                    انتخاب کنید
                </option>

                {options.map(item => (

                    <option
                        key={item.value}
                        value={item.value}
                    >
                        {item.label}
                    </option>

                ))}

            </select>

            {error && (
                <p className="text-red-500 text-xs mt-2">
                    {error}
                </p>
            )}

        </div>

    );

}